import { useMemo } from "react";
import { useContextProfile } from "@/app/module/index";

export function useProfile() {
  const {
    fetchAvatar,
    fetchUpdateProfileImage,
    fetchUpdateProfile,
    fetchUpdateCurrentAccount,
    fetchRemoveAccountProfile,
    fetchUserImage,
    profile,
    profileAccounts,
    profileImage,
  } = useContextProfile();

  return useMemo(
    () => ({
      fetchAvatar,
      fetchAvatarByLogin: fetchUserImage,
      updateAvatar: fetchUpdateProfileImage,
      update: fetchUpdateProfile,
      changeCurrentAccount: fetchUpdateCurrentAccount,
      removeAccount: fetchRemoveAccountProfile,
      profile: profile,
      accounts: profileAccounts,
      avatar: profileImage,
    }),
    [profile, profileAccounts, profileImage],
  );
}
